module.exports = __webpack_public_path__ + "static/img/gcgl_p3.59d411b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/gcgl_p3.png
// module id = lAEY
// module chunks = 19